var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.5V4.375C13.125 3.87772 12.9275 3.40081 12.5758 3.04917C12.2242 2.69754 11.7473 2.5 11.25 2.5H6.25C5.75272 2.5 5.27581 2.69754 4.92417 3.04917C4.57254 3.40081 4.375 3.87772 4.375 4.375V15.625C4.375 16.1223 4.57254 16.5992 4.92417 16.9508C5.27581 17.3025 5.75272 17.5 6.25 17.5H11.25C11.7473 17.5 12.2242 17.3025 12.5758 16.9508C12.9275 16.5992 13.125 16.1223 13.125 15.625V12.5M10 7.5L7.5 10M7.5 10L10 12.5M7.5 10H18.125",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.b486eda6b91615f908d80901e5fe51d7.svg";
export { ForwardRef as ReactComponent };